import api from '@/api/api';

const state = {
    testResults: [],
    currentTestResults: [],
};

const getters = {
    testResults: state => state.testResults,
    currentTestResults: state => state.currentTestResults,
    currentTestResultById: state => id => {
        return state.currentTestResults.find(item => item.id.toString() === id.toString());
    }
};

const mutations = {
    SET_TEST_RESULTS(state, testResults) {
        state.testResults = testResults;
    },
    CLEAR_TEST_RESULTS(state) {
        state.testResults = [];
    },
    SET_CURRENT_TEST_RESULTS(state, testResults) {
        state.currentTestResults = testResults;
    },
};

const actions = {
    /**
     * Fetch all test results and save it to state.
     * @return {Promise} result.
     */
    async fetchTestResults({ commit }, { filters }) {
        try {
            const {
                test_cases, test_results, target_builds, target_builds_count
            } = await api.testResults.fetchAll({ filters });

            commit('SET_TEST_RESULTS', test_results);
            commit('TestCases/SET_TEST_CASES', test_cases, { root: true });
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS', target_builds, { root: true });
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS_TOTAL_COUNT', target_builds_count, { root: true });
        } catch (error) {
            return Promise.reject('Error of test runs list fetching');
        }
    },
    /**
     * Fetch test results for all platforms and it to state.
     * @return {Promise} result.
     */
    async fetchTestResultsForAllPlatforms({ commit }, { filters }) {
        commit('SET_CURRENT_TEST_RESULTS', []);
        commit('Platforms/SET_CURRENT_PLATFORMS', [], { root: true });
        try {
            const { test_results, platforms,
                    target_build, test_case } = await api.testResults.fetchByTargetBuildAndTestCase(filters);
            commit('SET_CURRENT_TEST_RESULTS', test_results);
            commit('Platforms/SET_CURRENT_PLATFORMS', platforms, { root: true });
            commit('TargetBuilds/ADD_TARGET_BUILD', target_build, { root: true });
            commit('TestCases/ADD_TEST_CASE', test_case, { root: true });
        } catch (error) {
            return Promise.reject('Error of test runs list fetching');
        }
    },
    /**
     * Fetch all test results and save it to state.
     * @return {Promise} result.
     */
    async fetchTargetBuildsPlatformsSummary({ commit }, { filters }) {
        try {
            const {
                platforms, test_results, target_builds, target_builds_count
            } = await api.testResults.fetchTargetBuildsPlatformsSummary(filters);

            commit('SET_TEST_RESULTS', test_results);
            commit('Platforms/SET_TEST_RUNS_PLATFORMS', platforms, { root: true });
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS', target_builds, { root: true });
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS_TOTAL_COUNT', target_builds_count, { root: true });
        } catch (error) {
            return Promise.reject('Error of test runs list fetching');
        }
    },
    async updateIssueUrl(context, { testResultId, issueUrl }) {
        try {
            return await api.testResults.updateIssueUrl(testResultId, issueUrl);
        } catch (error) {
            return Promise.reject('Error of issue url updating');
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
